export default "__VITE_ASSET__504c957f__"